import { Component, OnInit } from '@angular/core';
import { UsersService } from '../../services/users.service';
import { User } from '../../models/user';
import { Group } from '../../models/group';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { DataService } from '../../../services/data.service';
import { TabForm } from '../../models/forms/tab-form';
import { TabType } from 'src/app/services/API.service';
import { _MatTabBodyBase } from '@angular/material/tabs';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.css']
})
export class UserManagementComponent implements OnInit  {
  dataSource: MatTableDataSource<User> = new MatTableDataSource();
  groups: Group[] = [];
  Tabs: FormArray = new FormArray([]);
  Defaults: string[] = [];
  emailList: string[] = [];

  constructor(private usrService: UsersService, private ds: DataService, private fb: FormBuilder) { }

  ngOnInit() {

    this.getGroups()
    .subscribe(obs => {
      this.getUsers();
      this.groups = obs;
    });

    this.ds.GetAllTabs()
    .subscribe(obs => {
      obs.sort((a,b) => a.UserID.localeCompare(b.UserID));
      obs.forEach(n => {
        this.Tabs.push(this.fb.group(new TabForm(n, this.fb)));
        if (n.Type == TabType.Default) {
          this.Defaults.push(n.RecordKey);
        }
      });
    });

  }

  onTabChanges(event: FormGroup) {

    if (event.dirty) {
      this.ds.AddUpdateTab(event);
    }
  }

  onTabDelete(event: string) {
    this.ds.DeleteTab(event);
  }

  onChanges(event: FormGroup) {
    const user = event.get('Username').value;
    const i = this.dataSource.data.findIndex(n => n.Username === user);

    if (event.get('GroupsUpdated').dirty) {
      const updated = event.get('GroupsUpdated').value;
      this.usrService.updateGroups(user, updated, event.get('Groups').value);

      this.dataSource.data[i].Groups = updated;
    }

    if (event.get('Enabled').dirty) {
      if (event.get('Enabled').value) {
        this.usrService.EnableUser(user);
      } else {
        this.usrService.DisableUser(user);
      }

      this.dataSource.data[i].setEnabled(event.get('Enabled').value);
    }
  }

  getUsers() {
    const users: User[] = [];

    this.usrService.ListUsers()
    .then(n => {
      for (const key in n.Users) {
        if (Object.prototype.hasOwnProperty.call(n.Users, key)) {
          const element = n.Users[key];
          const user = new User(element);

          this.emailList.push(user.Email);
          
          this.ds.GetTabsByUser(user.Email)
          .subscribe(t => {
            t.forEach(n => {
              user.Tabs.push(n);
            });
          });

          this.usrService.GetUserGroups(user.Username)
          .then(g => {
            user.addGroups(g.Groups);
          });

          users.push(user);
        }
      }

      this.dataSource.data = this.dataSource.data.concat(users);

      if (this.usrService.nextToken) {
        this.getUsers();
      }
    });
  }

  getGroups(): Observable<Group[]> {
    const groups: Group[] = [];

    return new Observable(obs => {
      this.usrService.GetGroups()
      .then(n => {
        for (const key in n.Groups) {
          if (Object.prototype.hasOwnProperty.call(n.Groups, key)) {
            const element = n.Groups[key];

            groups.push(new Group(element));
          }
        }

        obs.next(groups);
      });
    });
  }
}
